<template>
  <popup class="chat-popup" :removeContentPadding="true" :close-action="handleClose">
    <template v-slot:content>
      <div class="chat-popup-content">
        <lottie-player
          class="popup-background"
          src="/animations/background-lottie.json"
          autoplay
          loop
        />
        <div class="popup-content-wrapper">
          <div class="popup-title">
            רוצה לדבר עם התזרים שלך?
          </div>
          <div class="popup-description">
            מהיום אפשר לשאול שאלות על התזרים שלך ולקבל תשובות מיד - בעזרת ה-AI של רייזאפ, בלי טבלאות, בלי חישובים - רק שיחה פשוטה שמבינה אותך.
          </div>
          <riseup-button
            @click="handleStart"
            class="popup-button"
            color="dark-blue"
            title="קדימה"
          />
          <div class="popup-secondary-text" @click="handleClose">
            בפעם אחרת
          </div>
        </div>
      </div>
    </template>
  </popup>
</template>

<script>
import { CHAT_POPUP_SEEN_KEY } from '@/constants/chat';
import BaseUI from '@riseupil/base-ui';
import { mapActions } from 'vuex';
import Chatbot from './Chatbot.vue';

export default {
  name: 'ChatPopup',
  components: {
    Popup: BaseUI.Popup,
    RiseupButton: BaseUI.RiseupButton,
  },
  props: {
    initialMessage: {
      type: String,
      required: false,
      default: null,
    },
    initiator: {
      type: String,
      required: false,
      default: null,
    },
  },
  methods: {
    ...mapActions('modalRootStore', ['openModal']),
    handleClose() {
      this.$emit('close');
    },
    handleStart() {
      localStorage.setItem(CHAT_POPUP_SEEN_KEY, 'true');
      this.$emit('close');
      this.openModal({
        component: Chatbot,
        props: { initialMessage: this.initialMessage, initiator: this.initiator },
        popupAlignment: 'menu',
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@riseupil/base-ui/src/scss/spacings";
@import "~@riseupil/base-ui/src/scss/riseup-colors";
@import "~@riseupil/base-ui/src/scss/border-radius";

.chat-popup {
  padding: 10px;
  border-radius: 34px;
  background-color: $riseup_beige;

  ::v-deep .top {
    padding-top: 0;
    padding-bottom: 0;
  }

  ::v-deep .action-icons-container {
    z-index: 3;
    .action-icon {
      color: $riseup_white;
    }
  }

}

.chat-popup-content {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  font-family: SimplerPro;
  padding: $ri-spacing-xl $ri-spacing-m;
  overflow: hidden;
  border-radius: 22px;
  pointer-events: none;
  background-color: $riseup_light_saturated_red;
}

.popup-background {
  position: absolute;
  bottom: 90px;
  left: 125px;
  width: 175%;
  height: 140%;
  z-index: 0;
  pointer-events: none;
}

.popup-content-wrapper {
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  pointer-events: auto;
}

.popup-title {
  font-weight: 900;
  font-family: SimplerProAlte;
  font-size: 40px;
  line-height: 1.1;
  color: #142AA0;
  margin-top: 65px;
  margin-bottom: 20px;
  width: 100%;
}

.popup-description {
  font-size: 16px;
  line-height: 1.5;
  color: #142AA0;
  margin-bottom: 25px;
  width: 100%;
}

.popup-button {
  width: 100%;
  margin-bottom: $ri-spacing-m;
  font-size: 16px !important;
}

.popup-secondary-text {
  font-size: 16px;
  color: #142AA0;
  cursor: pointer;
  text-decoration: underline;
  margin-top: $ri-spacing-s;

  &:hover {
    opacity: 0.8;
  }
}
</style>

<style lang="scss">
.overlay-content:has(.chat-popup) {
  border-radius: 34px !important;
  align-self: center;
}
</style>
